// insert dropdown icons in masthead menu
$('.masthead__nav .menu > .menu-item-has-children > a').append('<i class="icon-right fas fa-sm fa-caret-down"></i>');